import styled from "styled-components";
import tw from "twin.macro";

const PageTitleStyles = styled.h2.attrs({
  className: "intro-y text-black font-medium text-lg font-medium mt-10 mr-auto",
})``;
export default PageTitleStyles;
